import { Subhead } from './Subhead';

export default Subhead;
